import { useRouter } from "next/router";
import React, { useCallback, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { webServiceClient } from "../../data/apiClient";
import useTrait from "../Common/syncUpdateState";

const MySwal = withReactContent(Swal);

const showAlert = (error) => {
  MySwal.fire({
    title: "Error Occured!",
    text: error,
    icon: "error",
    timerProgressBar: false,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: "Close"
  });
};
const PartSearchComponent = (props) => {
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const [isLoading ,setIsLoading]= useState(false);
  const isRedirecting = useTrait(false);
  const [options, setOptions] = useState([]);
  const [query, setQuery] = useState('');
  const partQuery = useRef();
  const apiService = webServiceClient(setIsLoading);
  const router = useRouter();
  const handleInputChange = (q) => {
    setQuery(q);
  };
 const onResult=(q)=>{
 // q.preventDefault();
  router.push("/part/" + q[0].itemName.toLowerCase());
 }

 const onSubmitResult=(q)=>{
  // q.preventDefault();
   router.push("/part/" + query);
  }
  const handleSearch = useCallback(async (q) => {
    try {
      const resp = await apiService.getPartNumberList(q);
      if (resp != null){
        
          setOptions(resp.data);
      }
        
    }
    catch (err) {
     // console.log(err);
      showAlert("Unexpected error occurred doing search");
    }
  }, []);
  return (
    <>
      <div className="">
        <div className="d-flex justify-content-center">
          <div className="row g-2">
            <div className="col-sm-8">
              {/* <input
                type="text"
                className="form-control mb-2 mr-sm-2"
                id="inlineFormInputName2"
                placeholder="Part Code"
              /> */}

              <AsyncTypeahead
                // className="form-control mb-2 mr-sm-2"
                ref={partQuery}
                id="part-search"
                labelKey={option => `${option.itemName}`}
                isLoading={isLoading}
                onSearch={handleSearch}
                onInputChange={handleInputChange}
                onChange={onResult}
                options={options}
                disabled={!isRedirecting}
                onKeyDown={(e)=>{
                  //console.log("test",partQuery);
                  if (e?.keyCode === 13 ) {
                    // Execute the search.
                    if(e?.target?.value!=null && e?.target?.value!=""){                      
                      partQuery?.current?.hideMenu(true);
                      isRedirecting.set(true);
                      router.push("/part/"+e?.target?.value.toLowerCase());
                    }
                   
                  }
                }}
                placeholder="Part Code"
                renderMenuItemChildren={(option) => (
                  <div key={option.itemName}>
                    {option.itemName}
                  </div>
                )}
                useCache={false}
              />
            </div>
            <div className="col-sm-4">
              <button onClick={onSubmitResult} className="btn btn-primary mb-2 w-100">
              {isRedirecting?.get() && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {!isRedirecting?.get() && "Search"}
                
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PartSearchComponent;